import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CrownIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_232_519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8786 4.66985C16.7798 4.52839 16.6484 4.41287 16.4954 4.3331C16.3425 4.25333 16.1725 4.21167 16 4.21167C15.8275 4.21167 15.6575 4.25333 15.5046 4.3331C15.3516 4.41287 15.2202 4.52839 15.1214 4.66985L8.35429 14.3384L2.83 8.81199C2.68015 8.66177 2.48907 8.55941 2.28098 8.51791C2.07289 8.47641 1.85717 8.49763 1.66115 8.57889C1.46514 8.66014 1.29766 8.79776 1.17996 8.97431C1.06225 9.15086 0.999622 9.35838 1 9.57057V23.4991C1 24.6358 1.45153 25.7259 2.25526 26.5296C3.05899 27.3333 4.14907 27.7849 5.28572 27.7849H26.7143C27.8509 27.7849 28.941 27.3333 29.7447 26.5296C30.5485 25.7259 31 24.6358 31 23.4991V9.57057C31.0004 9.35838 30.9377 9.15086 30.82 8.97431C30.7023 8.79776 30.5349 8.66014 30.3389 8.57889C30.1428 8.49763 29.9271 8.47641 29.719 8.51791C29.5109 8.55941 29.3198 8.66177 29.17 8.81199L23.6457 14.3384L16.8786 4.66985Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_232_519">
          <rect width="30" height="30" fill="currentColor" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
